export enum UserRole {
  guest,
  general,
  member,
  gameOwner,
  owner
}
